import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Tooltip,
} from "@mui/material";
import {} from "../models/ResponseModels/DetailsImageResponse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import config from "../config";
import { logDownload, DownloadOptions } from "../Utilities";
import Alert from "@mui/material/Alert";
import StarIcon from "@mui/icons-material/Star";
import CropOriginalIcon from "@mui/icons-material/CropOriginal";
import HideImageIcon from "@mui/icons-material/HideImage";
import saveAs from "file-saver";
import { ImagesInfo } from "../models/ResponseModels/DetailsResponse";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useState } from "react";
import MassiveDownloadDropMenu from "./MassiveDownloadDropMenu";
import AccessTimeSharpIcon from "@mui/icons-material/AccessTime";

interface Props {
  index: string;
  label: string;
  imagesArray: ImagesInfo[];
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  uuid: string | null;
  setSelectedUuid: React.Dispatch<React.SetStateAction<string>>;
  expandedList: string[] | null;
  setExpandedList: React.Dispatch<React.SetStateAction<string[] | null>>;
  workOrderTitle: string;
}

export default function ImagesTypeAccordionBox(props: Props) {
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);

  function handleAccordionChange(index) {
    // Funzione per cambiare lo stato dell'espansione di un singolo accordion
    props.setExpandedList((prevExpanded) => {
      if (prevExpanded.includes(index)) {
        return prevExpanded.filter((i) => i !== index); // Elimina l'index dalla lista
      } else {
        return [...prevExpanded, index]; // Aggiungi index dalla lista
      }
    });
  }

  function openDownloadModal(uuid: string) {
    //save scroll position
    const scrollY = window.scrollY;
    console.log("scrollY:", scrollY);
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    //open modal
    props.setSelectedUuid(uuid);
    props.setOpenModal(true);
  }

  function getDownloadImageFilename(image: ImagesInfo) {
    let imageFileName = "";
    if (image.title) {
      imageFileName = image.title;
    } else {
      const today = new Date();
      const formattedDate = today.toLocaleDateString();
      imageFileName = "image" + formattedDate;
    }

    const fileExtension = image.fileExtension ? image.fileExtension : "jpg";
    imageFileName = imageFileName + "." + fileExtension;
    return imageFileName;
  }

  function downloadOriginalImage(image: ImagesInfo) {
    if (image.essence) {
      const url =
        config.cloudfrontImgUrl + "" + image.essence + config.showImagesQuery;
      const imageFileName = getDownloadImageFilename(image);

      saveAs(url, imageFileName);

      logDownload(image.uuid, null);
    }
  }

  async function getDownloadImagesMap(): Promise<{
    [key: string]: DownloadOptions;
  }> {
    return new Promise((resolve) => {
      let imageUrlsMap: { [key: string]: DownloadOptions } = {};

      props.imagesArray.forEach((image) => {
        if (!image.isDownloadable || !image.essence) {
          return; //skip iteration
        }
        const url =
          config.cloudfrontImgUrl + "" + image.essence + config.showImagesQuery;

        const imageFileName = getDownloadImageFilename(image);

        imageUrlsMap[url] = {
          uuid: image.uuid,
          template: null,
          fileName: imageFileName,
          resolution: null,
          ratio: null,
          previewUrl: null,
        };
      });

      resolve(imageUrlsMap);
    });
  }

  return (
    <Accordion
      key={"accordionBox_type_" + props.index}
      expanded={props.expandedList.includes("accordionBox_type_" + props.index)}
      onChange={() => handleAccordionChange("accordionBox_type_" + props.index)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <div className="font-skyBold text-lg ">{props.label}</div>
      </AccordionSummary>
      <AccordionDetails>
        {showAlert ? <Alert severity="error">{alertMessage}</Alert> : <></>}
        <div className="float-right mb-2">
          <MassiveDownloadDropMenu
            getDownloadImagesMap={getDownloadImagesMap}
            loading={loading}
            setLoading={setLoading}
            success={success}
            setSuccess={setSuccess}
            error={error}
            setError={setError}
            isButtonDisabled={loading}
            setAlertMessage={setAlertMessage}
            setShowAlert={setShowAlert}
            workOrderTitle={props.workOrderTitle}
          />
        </div>
        {props.imagesArray.length > 0 ? (
          <Grid className="float-left p-4" container spacing={4}>
            {props.imagesArray.map((image, index) => (
              <Grid item xs={6} md={3} key={props.index}>
                <Card
                  className="mx-auto border border-gray-100 transition-all duration-300 hover:shadow-[0_0px_15px_rgba(25,118,210,0.8)] hover:border-2 hover:p-1 hover:border-[rgba(25,118,210,0.5)]"
                  sx={{ height: 320 }}
                  onClick={() => openDownloadModal(image.uuid)}
                >
                  <CardMedia
                    sx={{
                      height: 140,
                      backgroundImage: `url(${
                        image.cover != null
                          ? config.cloudfrontImgUrl +
                            image.cover +
                            config.showImagesQuery
                          : image.proxy != null
                          ? config.cloudfrontImgUrl +
                            image.proxy +
                            config.showImagesQuery
                          : config.placeholderImageUrl
                      })`,
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                  <CardContent>
                    <div className="flex flex-column justify-between min-h-8">
                      <div
                        className={`mt-auto mb-auto ${
                          image.isGreenStar && image.isGreenStar == true
                            ? "visible"
                            : "invisible"
                        } `}
                      >
                        <StarIcon style={{ color: "green" }} />
                      </div>

                      <div
                        className={`mt-auto mb-auto ${
                          image.isReleased == false ? "visible" : "invisible"
                        } `}
                      >
                        <Tooltip
                          title="This image is released"
                          placement="top-start"
                        >
                          <CalendarMonthIcon color="primary" />
                        </Tooltip>
                      </div>

                      <div
                        className={`mt-auto mb-auto ${
                          image.isEmbargoFlag == true ? "visible" : "invisible"
                        } `}
                      >
                        <Tooltip
                          title="Embargo is pending"
                          placement="top-start"
                        >
                          <AccessTimeSharpIcon color="primary" />
                        </Tooltip>
                      </div>

                      <div
                        className={`mt-auto mb-auto ${
                          image.hasCrop && image.hasCrop == true
                            ? "visible"
                            : "invisible"
                        } `}
                      >
                        <Tooltip
                          title="This image has crops available"
                          placement="top-start"
                        >
                          <CropOriginalIcon color="primary" />
                        </Tooltip>
                      </div>
                    </div>
                    <div className="text-base min-h-10 line-clamp-2 font-skyMedium ">
                      {image.title}
                    </div>
                    <div
                      className={`text-sky-400 font-skyMedium text-center bg-sky-500 text-white mb-3 rounded-[10px] ${
                        image.isInternalOnly && image.isInternalOnly == true
                          ? "visible"
                          : "invisible"
                      }`}
                    >
                      Internal Only
                    </div>
                    <div className="flex justify-center mb-1">
                      {image.isDownloadable && (
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          onClick={(event) => {
                            event.stopPropagation();
                            downloadOriginalImage(image); // Passes the event and image to the function
                          }}
                        >
                          Download
                        </Button>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <div className="font-skyRegular text-gray-500 text-center py-2">
            <HideImageIcon color="disabled" /> <p>No content available</p>
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
